export default __webpack_public_path__ + "static/media/codepen.19421539.webp";